/** Shared invalidation signal when authoritative current-plan data changes. */
export const ACTIVE_PLAN_CHANGED_EVENT = "endurava:active-plan-changed";

/** @deprecated Use ACTIVE_PLAN_CHANGED_EVENT */
export const LEGACY_ACTIVE_PLAN_CHANGED_EVENT = ACTIVE_PLAN_CHANGED_EVENT;

export const notifyActivePlanChanged = (detail = {}) => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(ACTIVE_PLAN_CHANGED_EVENT, { detail }));
};
